<template>
  <div class="drug">
    <el-button icon="el-icon-refresh" @click="$refresh(getDrugsList)" class="refresh-btn">刷新</el-button>
    <div class="drugwrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="名称">
            <el-input v-model.trim="searchForm.searchValue" placeholder="请输入药品名称" />
          </el-form-item>
          <el-form-item label="货号">
            <el-input v-model.trim="searchForm.artNo" placeholder="请输入药品货号" />
          </el-form-item>
          <el-form-item label="spuId">
            <el-input v-model.trim="searchForm.spuId" placeholder="请输入药品supId" />
          </el-form-item>
          <el-form-item label="spuName">
            <el-input v-model.trim="searchForm.spuName" placeholder="请输入药品spuName" />
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-cascader v-model="searchForm.types" :options="levelOptions" ref="cascader" 
              :props="{ multiple: true, emitPath: false }" collapse-tags :show-all-levels="false" clearable></el-cascader>
          </el-form-item>
          <el-form-item label="货位">
            <el-input v-model.trim="searchForm.position" placeholder="请输入药品货位" />
          </el-form-item>
          <el-form-item label="追溯码管理">
            <el-select v-model="searchForm.traceStatus" clearable>
              <el-option v-for="item in traceStatusOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="医保属性">
            <el-select v-model="searchForm.medicalInsuranceType" clearable>
              <el-option v-for="item in medicalInsuranceTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="雨诺类型">
            <el-cascader
              v-model="searchForm.yuNuoType"
              :options="drugCateList"
              :show-all-levels="false"
              :props="{ checkStrictly: true, label: 'name', value: 'code', emitPath: false }"
              clearable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="医保编码">
            <el-select v-model="searchForm.ybCode" clearable placeholder="请选择状态">
              <el-option value="" label="全部"></el-option>
              <el-option value="1" label="有"></el-option>
              <el-option value="2" label="无"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getDrugsList, true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getDrugsList, { searchValue: null, artNo: null, types: null,traceStatus:'',medicalInsuranceType:null, ybCode:'' })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 药品列表 -->
      <CustomTable v-loading="loading" :column="listTable" :tableData="drugList" :max-height="tableHeight">
        <template slot="firstCategory" slot-scope="{row}">
          {{ computedLevel(row.firstCategory) }}
        </template>
        <template slot="secondCategory" slot-scope="{row}">
          {{ computedLevel(row.secondCategory) }}
        </template>
        <template slot="traceStatus" slot-scope="{row}">
          <el-switch :disabled="![0,-1].includes(deptId)" v-model="row.checked" @change="changeTrace($event, row)"></el-switch>
        </template>
        <template slot="valuableDrug" slot-scope="{row}">
          <el-switch :disabled="![0,-1].includes(deptId)" v-model="row.valuableFlag" active-value="1" inactive-value="0" @change="changeValuableDrug($event, row)"></el-switch>
        </template>
        <template slot="handle" slot-scope="{row}">
          <div>
            <el-button type="text" v-if="[0,-1].includes(deptId)" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" @click="handleEdit(row, 'position')">编辑货位</el-button>
            <el-button type="text" v-if="[0,-1].includes(deptId)" @click="handleEditMedicalInsuranceType(row)">编辑医保属性</el-button>
            <el-button type="text" @click="handleSync(row)">同步库存</el-button>
          </div>
        </template>
      </CustomTable>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getDrugsList)" :total="total"
        :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
    </div>
    <!-- 弹框 -->
    <customDialog :title="'修改' + (editType === 'position' ? '货位' : '')" width="560px" v-if="dialogShow" :visible.sync="dialogShow" @close="closeDialog"
      @save="submit">
      <el-form slot="content" :model="editForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="货号" prop="id">
          <el-input v-model.trim="editForm.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="商品通用名称" prop="drugCommonName">
          <el-input v-model.trim="editForm.drugCommonName" disabled></el-input>
        </el-form-item>
        <el-form-item v-if="editType !== 'position'" label="商品名称" prop="drugName">
          <el-input v-model.trim="editForm.drugName" maxlength="20" > </el-input>
        </el-form-item>
        <el-form-item v-if="editType !== 'position'" label="类型" prop="types">
          <el-cascader
            v-model="editForm.types"
            style="width:100%"
            :options="levelOptions"
            ref="cascader"
            collapse-tags
            :show-all-levels="false"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item v-if="editType !== 'position'" label="药品编码" prop="dictDrugCode">
          <el-input v-model.trim="editForm.dictDrugCode" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item v-if="editType !== 'position'" label="医保">
          <el-radio-group v-model="editForm.ybCenterDrugDirectoryCategorySign">
            <el-radio v-for="item in ybCenterDrugDirectoryCategorySignList" :key="item.value" :label="item.value">{{
              item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="editType === 'position'"> 
          <el-form-item :label="'货位（配方区'+ index +')'" prop="position" v-for="(item,index) in editForm.positionObj">
            <div class="form-content">
              <el-form-item label="">
                <el-select
                  v-model="item.positionFirstField"
                  class="form-content-item"
                  clearable
                  @change="handleFirstFieldChange"
                >
                  <el-option
                    v-for="item in letterOption"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <span>-</span>
              <el-form-item label="" :prop="'positionObj.'+index +'.positionSecondField'" :rules="{ pattern: reg, message, trigger: 'change' }">
              <el-input
                v-model.trim="item.positionSecondField"
                class="form-content-item"
                :disabled="!item.positionFirstField"
                @input="handleSecondFieldChange"
              ></el-input>
              </el-form-item>
              <span>-</span>
              <el-form-item label="" :prop="'positionObj.'+index +'.positionThirdField'" :rules="{ pattern: reg, message, trigger: 'change' }">
                <el-input
                  v-model.trim="item.positionThirdField"
                  class="form-content-item"
                  :disabled="!item.positionSecondField"
                  @input="handleThirdFieldChange"
                ></el-input>
              </el-form-item>
              <span>-</span>
              <el-form-item label="" :prop="'positionObj.'+index +'.positionFourthField'" :rules="{ pattern: reg, message, trigger: 'change' }">
                <el-input
                  v-model.trim="item.positionFourthField"
                  class="form-content-item"
                  :disabled="!item.positionThirdField"
                ></el-input>
              </el-form-item>
            </div>
          </el-form-item>
        </template>
      </el-form>
    </customDialog>
    <customDialog :title="'修改医保属性'" width="560px" v-if="medicalInsuranceTypeDialogShow" :visible.sync="medicalInsuranceTypeDialogShow" @close="medicalInsuranceClose" @save="medicalInsuranceSubmit">
      <el-form slot="content" :model="medicalInsuranceForm" :rules="medicalInsuranceRules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="医馆：" prop="deptName">
          <div>{{ medicalInsuranceForm. deptName}}</div>
        </el-form-item>
        <el-form-item label="货号：" prop="deptName">
          <div>{{ medicalInsuranceForm.id }}</div>
        </el-form-item>
        <el-form-item label="商品通用名称：" prop="deptName">
          {{ medicalInsuranceForm.drugCommonName}}
        </el-form-item>
        <el-form-item label="医保属性：" prop="deptName">
          <el-radio-group v-model="medicalInsuranceForm.medicalInsuranceType">
            <el-radio :label="'2'">可统筹</el-radio>
            <el-radio :label="'3'">仅个账</el-radio>
            <el-radio :label="'1'">不过医保</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="form_footer">
        <el-button type="primary" @click="medicalInsuranceSubmit(0)">本馆应用</el-button>
        <el-button @click="medicalInsuranceSubmit(1)">全馆应用</el-button>
        <el-button @click="medicalInsuranceClose">取消</el-button>
      </div>
    </customDialog>
  </div>
</template>

<script lang="js">
import { drugList, edit, editPosition, changeTraceStatus, changeValuableDrugStatus,editMedicalInsuranceType,fireSync } from "@/api/drug"; // 药品请求
import { dictText,isEmpty,isNull } from '@/utils/validateBase'
import customDialog from '@/components/customDialog/CustomDialog.vue'
import { ybCenterDrugDirectoryCategorySignList,ybPropertyList } from '@/utils/const';
import CustomTable from '@/components/CustomTable.vue';
import { CommonDTO } from '@/DTO/index.js'
import {Common} from './DTO/common'
const letterOption = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
const reg = /^\d{1,3}$|^$/  // /^([0-9]\d{0,2})$/
const message = '请输入0-999之间的整数'
export default {
  data() {
    return {
      reg:reg,
      message:message,
      loading: true, // 加载中
      searchForm: { searchValue: null, artNo: null, types: null, position: '', traceStatus: '',medicalInsuranceType:null,spuId:null,spuName:null, ybCode:'' }, // 查询表单
      traceStatusOption: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '开启',
          value: '1'
        },
        {
          label: '关闭',
          value: '0'
        },
      ],
      drugRoleList: [],
      drugCateList: [],
      drugList: [], // 药品列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      tableHeight: 0, // 表格最大高度
      deptId: this.$session.get('deptId'), // 当前医馆id
      deptOptions: this.$session.get('options'), // 医馆列表
      dialogShow: false,//弹框显示
      editForm: {},
      editType: '',//编辑类型  ''代表编辑 'position'代表编辑货位’
      letterOption,
      rules: {
        drugName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
        // dictDrugCode: [
        //   { required: true, message: '请输入医保编码', trigger: 'blur' },
        // ],
        types: [
          { required: true, message: '请选择类型', trigger: 'change' },
        ],
        positionSecondField: [
          { pattern: reg, message, trigger: 'change' }
        ],
        positionThirdField: [
          { pattern: reg, message, trigger: 'change' }
        ],
        positionFourthField: [
          { pattern: reg, message, trigger: 'change' }
        ]

      },
      ybCenterDrugDirectoryCategorySignList: ybCenterDrugDirectoryCategorySignList,//药品类别
      levelOptions: [],//
      flattenLevelOptions:[],//
      listTable: [
        { label: "序号", type: "index", width: '80' },
        {
          label: "医馆", prop: "deptId", formatter: (row => {
            return dictText(row.deptId, this.$session.get('options'))
          }), minWidth: "100"
        },
        { label: "货号", prop: "id", minWidth: "120" },
        { label: "是否禁用",formatter: (row => { return row.validFlag == 1 ? '是' : '否'  }),width: "100" },
        { label: "spuId", prop: "spuId", minWidth: "100" },
        { label: "spuName", prop: "spuCommonName", minWidth: "180" },
        // { label: "商品通用名称", prop: "drugCommonName", minWidth: "180" },
        { label: "商品名称", prop: "drugName", minWidth: "180" },
        { label: "一级分类", prop: "firstCategory", slotName:'firstCategory', minWidth: "120" },
        { label: "二级分类", prop: "secondCategory", slotName:'secondCategory', minWidth: "120" },
        { label: "可用库存", prop: "inventory", minWidth: "120" },
        { label: "单位", prop: "unit", minWidth: "120" },
        { label: "零售价", prop: "price", minWidth: "100" },
        { label: "规格", prop: "specifications", minWidth: "120" },
        { label: "厂家", prop: "manufacturer", minWidth: "200" },
        { label: "医保编码", prop: "dictDrugCode", minWidth: "150" },
        {
          label: "医保类别", prop: "ybCenterDrugDirectoryCategorySign", formatter: (row => {
            return dictText(row.ybCenterDrugDirectoryCategorySign, ybCenterDrugDirectoryCategorySignList)
          }), minWidth: "120"
        },
        {
          label: "医保属性", prop: "medicalInsuranceType", formatter: (row => {
            return dictText(row.medicalInsuranceType, ybPropertyList)
          }), minWidth: "120"
        },
        { label: "雨诺类别", prop: "categoryFirstName", minWidth: "150" },
        { label: "零售大类", prop: "categorySecondName", minWidth: "150" },
        { label: "零售中类", prop: "categoryThirdName", minWidth: "150" },
        { label: "零售小类", prop: "categoryFourthName", minWidth: "150" },
        { label: "商品角色", prop: "roleName", minWidth: "150" },
        // { label: "货位", prop: "position", minWidth: "150" },
        // 动态加载货位
        { label: "追溯码管理", prop: "traceStatus", minWidth: '130', slotName: 'traceStatus', fixed: "right" },
        { label: "贵重药材", prop: "valuableDrug", minWidth: '130', slotName: 'valuableDrug', fixed: "right" },
        { label: "操作", prop: "id", minWidth: '150', slotName: 'handle', fixed: "right" },
      ],
      medicalInsuranceTypeOption:ybPropertyList,
      medicalInsuranceTypeDialogShow:false,
      medicalInsuranceRules:{
        drugName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
      },
      medicalInsuranceForm:{}
    };
  },
  components: { customDialog, CustomTable },
  async created() {
    this.tableHeight = document.documentElement.clientHeight - 290;
    await this.getDrugRole();
    this.getDrugCate();
    this.getDrugsList(); // 页面初始化获取药品列表
    this.getGoodLevel();//获取分类列表
    this.getPositionTitle()
  },
  computed:{
    computedLevel(){
      let that=this;
      return function(level){
        return dictText(level, that.flattenLevelOptions)
      }
    },
  },
  methods: {
    getPositionTitle(){
      let recipeAreasNum = this.$session.get('deptInfo').recipeAreasNum || 1
      let index = this.listTable.findIndex(v=>{return v.prop === 'traceStatus'})
      for (let i = 1; i <= recipeAreasNum; i++) {
        this.listTable.splice(index+i, 0, { label: `配方区${i}货位`, width: 130,formatter:(row)=>{
          return row.positions ? row.positions[i] : ''
        } })
      }
    },
    // 获取商品角色
    async getDrugRole() { 
      const res = await CommonDTO.getDrugRoleOrCate({ type: 'goodsRole' })
      if (res.errorCode == '0000') {
        this.drugRoleList = res.data
      }
    },
    // 获取商品分类
    async getDrugCate() { 
      const res = await CommonDTO.getDrugRoleOrCate({ type: 'goodsCate' })
      if (res.errorCode == '0000') {
        this.drugCateList = res.data
      }
    },
    //获取分类列表
    async getGoodLevel() {
      let res = await CommonDTO.getDictTypeTreeDTO('level')
      if (res.code == 200) {
        let data = Common.deleteEmptyChildren(res.data)
        this.levelOptions = data
        this.levelOptions.push({ label: '未选择一级分类', value: '0' })
        this.flattenLevelOptions=Common.flattenChildren(data)
      }
    },
    // 请求所有药品列表
    async getDrugsList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await drugList(params);
      if (code == 200) {
        this.total = total;
        rows.forEach(item => {
          item.inventory = Number(item.inventory)
          this.deptOptions.forEach(kid => {
            if (item.deptId == kid.value) item.deptName = kid.label;
          })
          item.checked = item.traceStatus === 1
          const role = this.drugRoleList.find(v=>{ return v.code == item.roleId })
          item['roleName'] = role ? role.name : ''
        })
        this.drugList = rows;
      }
      this.loading = false;
    },
    /**
     * 关闭弹框
     */
    closeDialog() {
      this.dialogShow = false
    },
    /**
     * 确定
     */
    submit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          // let firstCategory = this.editForm.types.filter(val => _.startsWith(val, 'f'))
          // let secondCategory = this.editForm.types.filter(val => _.startsWith(val, 's'))
          // if (!_.isEmpty(firstCategory)) {
          //   this.editForm.firstCategory = firstCategory[0]
          // }else{
          //   this.editForm.firstCategory=''
          // }
          // if (!_.isEmpty(secondCategory)) {
          //   this.editForm.secondCategory = secondCategory[0]
          // }else{
          //   this.editForm.secondCategory=''
          // }
          let params = {}
          if(this.editType == 'position') {
            for (const key in this.editForm.positionObj) {
              const positionInfoArr = [this.editForm.positionObj[key].positionSecondField, this.editForm.positionObj[key].positionThirdField, this.editForm.positionObj[key].positionFourthField].filter(item => item.trim() !== '')
              let positionStr = ''
              if(this.editForm.positionObj[key].positionFirstField) {
                positionStr = this.editForm.positionObj[key].positionFirstField
                if(positionInfoArr.length > 0) {
                  positionStr += ('-' + positionInfoArr.join('-'))
                }
              }
              if(isNull(positionStr)){
                delete this.editForm.positionObj[key]
              }else{
                this.editForm.positionObj[key] = positionStr
              }
            }
            params = {
              id: this.editForm.id,
              deptId: this.editForm.deptId,
              positions: this.editForm.positionObj
            }
          } else {
            params = {
              ...this.editForm
            }
          }
          try {
            const res = this.editType === 'position' ? await editPosition(params) : await edit(params)
            if (res.code == 200) {
              this.$message.success('修改成功')
              this.dialogShow = false;
              this.getDrugsList()
            }
          } catch (error) {
            console.log('编辑失败');
          }
          
        }
      });
    },
    /**
     * 
     */
    handleEdit(row, type = '') {
      this.editType = type
      const recipeAreasNum = this.$session.get('deptInfo').recipeAreasNum || 1
      // this.$set(this, 'editForm', row)
      let positionObj = {}
      const positionFiledList = ['positionFirstField', 'positionSecondField', 'positionThirdField', 'positionFourthField']
      for(let i = 1; i <= recipeAreasNum ; i++){
        let obj = {}
        positionFiledList.forEach((el, index) => {
          obj[el] = ''
        })
        positionObj[i]= obj
      }
      for (const key1 in positionObj) {
        for (const key2 in row.positions) {
          if(key1 == key2){
            let obj = {}
            const positionInfoArr = row.positions[key2].split('-')
            positionFiledList.forEach((el, index) =>{
              obj[el] = positionInfoArr[index] || ''
            })
            positionObj[key1] = obj
          }
        }
      }
      this.editForm=_.cloneDeep(row)
      let levelArr = _.compact([row.firstCategory, row.secondCategory])
      this.$set(this.editForm, 'types', levelArr)
      this.$set(this.editForm, 'positionObj', positionObj)
      console.log(this.editForm);
      this.dialogShow = true
    },
    handleEditMedicalInsuranceType(row){
      let { deptId,drugId,drugCommonName,medicalInsuranceType,id} =  row
      this.medicalInsuranceForm = {
        id,
        deptName: dictText(deptId, this.$session.get('options')),
        drugId,
        drugCommonName,
        medicalInsuranceType:medicalInsuranceType || '',
        deptId
      }
      this.medicalInsuranceTypeDialogShow = true
    },
    /**
     * 处理药品类别数据
     */
    formatterDrugType(row) {
      return dictText(row.ybCenterDrugDirectoryCategorySign, this.ybCenterDrugDirectoryCategorySignList)
    },

    // 货位选择器change事件
    handleFirstFieldChange(e) {
      if(!e) {
        this.$set(this.editForm, 'positionSecondField', '')
        this.$set(this.editForm, 'positionThirdField', '')
        this.$set(this.editForm, 'positionFourthField', '')
      }
    },

    handleSecondFieldChange(e) {
      if(e.trim() === '') {
        this.$set(this.editForm, 'positionThirdField', '')
        this.$set(this.editForm, 'positionFourthField', '')
      }
    },

    handleThirdFieldChange(e) {
      if(e.trim() === '') {
        this.$set(this.editForm, 'positionFourthField', '')
      }
    },

    // 更改追溯码状态
    async changeTrace(e, itemInfo) {
      const params = {
        drugId: itemInfo.drugId,
        traceStatus: e ? 1 : 0
      }
      try {
        const res = await changeTraceStatus(params)
        if(res.code != 200) {
          const index = this.drugList.findIndex(item => item.drugId == itemInfo.drugId)
          if (index > -1) {
            this.$set(this.drugList[index], 'checked', !e)
          }
        }
      } catch (error) {
        console.log('修改追溯码状态失败', error)
      }
    },
    // 更新贵重药材状态
    async changeValuableDrug (e, itemInfo) {
      const params = {
        drugId: itemInfo.drugId,
        valuableFlag: e
      }
      try {
        const res = await changeValuableDrugStatus(params)
        this.getDrugsList()
      } catch (error) {
        console.log('修改贵重药材状态失败', error)
      }
    },
    //医保属性弹框关闭
    medicalInsuranceClose(){
      this.medicalInsuranceForm = {}
      this.medicalInsuranceTypeDialogShow=false
    },
    //医保属性确认 value 0 本馆 1全馆
    async medicalInsuranceSubmit(value){
      let { deptId, medicalInsuranceType,id } = this.medicalInsuranceForm
      let obj = { artNo:id,medicalInsuranceType,deptId:value === 1 ? '' : deptId}
      let {code,data} = await editMedicalInsuranceType(obj)
      if(code===200){
        this.$message.success('修改医保属性成功')
        this.medicalInsuranceClose()
        this.getDrugsList()
      }
    },
    async handleSync(row){
      let {code,data} = await fireSync({pha_num:this.$session.get('deptInfo').mapDeptCode,med_num:row.id})
      if(code == '0000' ){
        this.$message.success('同步成功！')
      }
    }
  },
};
</script>

<style lang="less" scoped>
  .drug {
    box-sizing: border-box;
    padding: 20px;
  }


.search {
  /deep/.el-input__suffix {
    height: 31px;
  }
}

.drugwrap {
  &>div:not(:last-child) {
    margin-bottom: 20px;
  }

  .drugEdit {
    .el-form-item {
      width: 80%;
    }

    /deep/input {
      width: 180px;
    }
  }
}

// 编辑弹窗中的货位样式
.form-content {
  width:100%;
  display:flex;
  justify-content:space-between;
  align-items:center;

  &-item {
    width: 90px;
  }

  /deep/.el-input__icon {
    height: 31px;
  }
}
.form_footer{
  text-align: right;
  padding-bottom: 20px;
  padding-right: 20px;
}

</style>